var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineAndSymbols(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "line_and_symbols",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M22,3.9l-3,3l-1-1l0.9-1.1c-1.4,0-2.5,0.5-3.6,1.5c-2,1.8-2.9,4.1-3.9,6.7c-0.5,1.4-1.1,2.9-1.9,4.3 c-0.7,1.2-1.5,2.3-2.4,3.1c-1,1-2,1.6-3.1,2.1C3.1,22.8,2.2,23,1.3,23H1v-2.1c2.6,0.1,4.9-1.4,6.7-4.6C8.4,15,9,13.6,9.5,12.2 c1-2.6,2.1-5.4,4.5-7.4c1.6-1.4,3-2.1,4.8-2L18,1.9l1-1L22,3.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "MultiColorIcon-path--white",
    d: "M5.9,4.5l2.8,2.8L7.3,8.7L4.5,5.9L1.7,8.7L0.3,7.3l2.8-2.8L0.3,1.7l1.4-1.4l2.8,2.8l2.8-2.8l1.4,1.4L5.9,4.5z M18.5,24C16,24,14,22,14,19.5s2-4.5,4.5-4.5s4.5,2,4.5,4.5S21,24,18.5,24z M18.5,17c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5 s2.5-1.1,2.5-2.5S19.9,17,18.5,17z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineAndSymbols);
export default __webpack_public_path__ + "static/media/line_and_symbols.a47dd110.svg";
export { ForwardRef as ReactComponent };